import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { changeUserSeason } from '../actions/userActions.js';
import { getSeasons, getSeasonsByActive , getSeasonsByDisplay} from '../actions/seasonActions.js';

import Main from './../components/Main';

const mapDispatchToProps = dispatch => {
  return {
    changeUserSeason: (userSeason) => {
      dispatch(changeUserSeason(userSeason));
    },
    getSeasons: () => {
      dispatch(getSeasons());
    },
    getSeasonsByActive: (active) => {
      dispatch(getSeasonsByActive(active));
    },
    getSeasonsByDisplay: (display) => {
      dispatch(getSeasonsByDisplay(display));
    }
  };
};

const mapStateToProps = state => ({
  userType: state.user.userType,
  umpireLevel: state.user.umpireLevel,
  seasons: state.seasons.seasons,
  seasonsList: state.seasons.seasonsList,
  userSeason: state.user.userSeason
});

const MainContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));
export default MainContainer;



// WEBPACK FOOTER //
// ./src/containers/MainContainer.js